import React, { useEffect, useState } from 'react'
import './SchedulePage.scss';
import { Autocomplete, TextField } from '@mui/material';
import { read, utils } from 'xlsx';
import { CheckboxItem } from './CheckboxItem';

const generarColorAleatorio = () => {
    const colores = [];
    const numColors = 40;
    for (let i = 0; i < numColors; i++) {
        const r = Math.floor(Math.random() * 100); // Valor de rojo
        const g = Math.floor(Math.random() * 100); // Valor de verde
        const b = Math.floor(Math.random() * 100); // Valor de azul
        const color = `rgb(${r}, ${g}, ${b})`; // Formato RGB
        colores.push(color);
    }
    const indice = Math.floor(Math.random() * colores.length);
    return colores[indice];
}

const getHour = (indice,select) => {
    const hours = [
        ["8:00","8:45"],
        ["8:45","9:30"],
        ["9:30","10:15"],
        ["10:30","11:15"],
        ["11:15","12:00"],
        ["12:00","12:45"],

        ["13:00","13:45"],
        ["13:45","14:30"],
        ["14:30","15:15"],
        ["15:30","16:15"],
        ["16:15","17:00"],
        ["17:00","17:45"],

        ["18:15","19:00"],
        ["19:00","19:45"],
        ["19:45","20:30"],
        ["20:30","21:15"],
        ["21:30","22:15"],
        ["22:15","23:00"],
    ];
    return hours[indice][select];
}

export const SchedulePage = () => {

    const [courses, setCourses] = useState([])
    const [selectedCourses, setSelectedCourses] = useState(null);


    useEffect(() => {
        const content = require('../../data/horarios.json')
        let data = []
        content.forEach( (obj, key) => {
            const row = {
                id: key,
                label: `${obj.subject} - ${obj.course} ${obj.notes ? '- '+obj.notes : ''}`,
                ...obj
            } 
            data.push(row)
        })
        setCourses(data)
    }, []);

    const handleCourseSelect = (event, courses) => {
        
        if(!courses){
            return
        }
        setSelectedCourses(courses);
        const containers = document.getElementsByClassName('content-day-courses');

        // Itera sobre cada elemento y elimina sus hijos
        Array.from(containers).forEach(container => {
            while (container.firstChild) {
                container.removeChild(container.firstChild);
            }
        });
        courses.forEach( (course) => {
            printCourse(course)
        })
        
    };
    
    const printCourse = (course) => {
        const color = generarColorAleatorio()
        if(course.monday){
            const container = document.getElementById('content-monday');
            let start = parseInt(course.monday[0])
            if(course.turn == 'T'){
                start = start + 6
            }
            
            if(course.turn == 'N'){
                start = start + 12
            }
            
            let end = parseInt(course.monday[course.monday.length - 1])
            if (course.monday[course.monday.length - 1] == '*'){
                end = parseInt(course.monday[course.monday.length - 2])
            }
            if(course.turn == 'T'){
                end = end + 6
            }
            
            if(course.turn == 'N'){
                end = end + 12
            }

            

            start++
            end++

            const newDiv = document.createElement('div');
            newDiv.className = 'container-horario'
            newDiv.style.backgroundColor = color
            newDiv.style.borderRadius = '10px';
            newDiv.style.gridRowStart = start;
            newDiv.style.gridRowEnd = end;
            newDiv.style.display = 'flex'
            newDiv.style.flexDirection = 'column'
            newDiv.style.justifyContent = 'space-between'
            newDiv.style.padding = '10px'
            newDiv.title = course.label
            newDiv.innerHTML = `
                <p>${getHour(start-1,0)}</p>
                <p class='materia-nombre'>${course.label}</p>
                <p>${getHour(end-1,1)}</p>
            `
            container.appendChild(newDiv);
            newDiv.scrollIntoView({ behavior: 'smooth' });
        }
        if(course.tuesday){
            
            const container = document.getElementById('content-tuesday');
            
            let start = parseInt(course.tuesday[0])
            if(course.turn == 'T'){
                start = start + 6
            }
            
            if(course.turn == 'N'){
                start = start + 12
            }

            let end = parseInt(course.tuesday[course.tuesday.length - 1])
            if(course.turn == 'T'){
                end = end + 6
            }
            
            if(course.turn == 'N'){
                end = end + 12
            }

            

            start++
            end++

            const newDiv = document.createElement('div');
            newDiv.className = 'container-horario'
            newDiv.style.backgroundColor = color
            newDiv.style.borderRadius = '10px';
            newDiv.style.gridRowStart = start;
            newDiv.style.gridRowEnd = end;
            newDiv.style.display = 'flex'
            newDiv.style.flexDirection = 'column'
            newDiv.style.justifyContent = 'space-between'
            newDiv.style.padding = '10px'
            newDiv.title = course.label
            newDiv.innerHTML = `
                <p>${getHour(start-1,0)}</p>
                <p class='materia-nombre'>${course.label}</p>
                <p>${getHour(end-1,1)}</p>      `
            container.appendChild(newDiv);
            newDiv.scrollIntoView({ behavior: 'smooth' });
        }
        if(course.wednesday){
            const container = document.getElementById('content-wednesday');
            
            let start = parseInt(course.wednesday[0])
            if(course.turn == 'T'){
                start = start + 6
            }
            
            if(course.turn == 'N'){
                start = start + 12
            }

            let end = parseInt(course.wednesday[course.wednesday.length - 1])
            if(course.turn == 'T'){
                end = end + 6
            }
            
            if(course.turn == 'N'){
                end = end + 12
            }

            

            start++
            end++

            const newDiv = document.createElement('div');
            newDiv.className = 'container-horario'
            newDiv.style.backgroundColor = color
            newDiv.style.borderRadius = '10px';
            newDiv.style.gridRowStart = start;
            newDiv.style.gridRowEnd = end;
            newDiv.style.display = 'flex'
            newDiv.style.flexDirection = 'column'
            newDiv.style.justifyContent = 'space-between'
            newDiv.style.padding = '10px'
            newDiv.title = course.label
            newDiv.innerHTML = `
                <p>${getHour(start-1,0)}</p>
                <p class='materia-nombre'>${course.label}</p>
                <p>${getHour(end-1,1)}</p>      `
            container.appendChild(newDiv);
            newDiv.scrollIntoView({ behavior: 'smooth' });
        }
        if(course.thursday){
            const container = document.getElementById('content-thursday');
            
            let start = parseInt(course.thursday[0])
            if(course.turn == 'T'){
                start = start + 6
            }
            
            if(course.turn == 'N'){
                start = start + 12
            }

            let end = parseInt(course.thursday[course.thursday.length - 1])
            if(course.turn == 'T'){
                end = end + 6
            }
            
            if(course.turn == 'N'){
                end = end + 12
            }

            

            start++
            end++

            const newDiv = document.createElement('div');
            newDiv.className = 'container-horario'
            newDiv.style.backgroundColor = color
            newDiv.style.borderRadius = '10px';
            newDiv.style.gridRowStart = start;
            newDiv.style.gridRowEnd = end;
            newDiv.style.display = 'flex'
            newDiv.style.flexDirection = 'column'
            newDiv.style.justifyContent = 'space-between'
            newDiv.style.padding = '10px'
            newDiv.title = course.label
            newDiv.innerHTML = `
                <p>${getHour(start-1,0)}</p>
                <p class='materia-nombre'>${course.label}</p>
                <p>${getHour(end-1,1)}</p>      `
            container.appendChild(newDiv);
            newDiv.scrollIntoView({ behavior: 'smooth' });
        }
        if(course.friday){
            const container = document.getElementById('content-friday');
            
            let start = parseInt(course.friday[0])
            if(course.turn == 'T'){
                start = start + 6
            }
            
            if(course.turn == 'N'){
                start = start + 12
            }

            let end = parseInt(course.friday[course.friday.length - 1])
            if(course.turn == 'T'){
                end = end + 6
            }
            
            if(course.turn == 'N'){
                end = end + 12
            }

            

            start++
            end++

            const newDiv = document.createElement('div');
            newDiv.className = 'container-horario'
            newDiv.style.backgroundColor = color
            newDiv.style.borderRadius = '10px';
            newDiv.style.gridRowStart = start;
            newDiv.style.gridRowEnd = end;
            newDiv.style.display = 'flex'
            newDiv.style.flexDirection = 'column'
            newDiv.style.justifyContent = 'space-between'
            newDiv.style.padding = '10px'
            newDiv.title = course.label
            newDiv.innerHTML = `
                <p>${getHour(start-1,0)}</p>
                <p class='materia-nombre'>${course.label}</p>
                <p>${getHour(end-1,1)}</p>      `
            container.appendChild(newDiv);
            newDiv.scrollIntoView({ behavior: 'smooth' });
        }
        if(course.saturday){
            const container = document.getElementById('content-saturday');
            
            let start = parseInt(course.saturday[0])

            
            let end = parseInt(course.saturday[course.saturday.length - 1])
            if (course.saturday[course.saturday.length - 1] == '*'){
                end = parseInt(course.saturday[course.saturday.length - 2])
            }

            

            start++
            end++

            const newDiv = document.createElement('div');
            newDiv.className = 'container-horario'
            newDiv.style.backgroundColor = color
            newDiv.style.borderRadius = '10px';
            newDiv.style.gridRowStart = start;
            newDiv.style.gridRowEnd = end;
            newDiv.style.display = 'flex'
            newDiv.style.flexDirection = 'column'
            newDiv.style.justifyContent = 'space-between'
            newDiv.style.padding = '10px'
            newDiv.title = course.label
            newDiv.innerHTML = `
                <p>${getHour(start-1,0)}</p>
                <p class='materia-nombre'>${course.label}</p>
                <p>${getHour(end-1,1)}</p>      `
            container.appendChild(newDiv);
            newDiv.scrollIntoView({ behavior: 'smooth' });
        }
    }

    return (
        <div className='schedule-page'>
            <div className="container-top-schedule">
                <Autocomplete
                multiple
                disablePortal
                id="combo-box-demo"
                options={courses}
                sx={{ padding: '20px', maxWidth: '70vw'  }}
                onChange={(event, value) => handleCourseSelect(event,value)}
                renderInput={(params) => <TextField {...params} label="Agregar horario" />}
                />
            </div>
            <div className="table-days">
                <div className='content-day'>
                    <p className='title-day'>Lunes</p>
                    <div className='content-day-courses' id='content-monday'></div>
                </div>
                <hr/>
                <div className='content-day'>
                    <p className='title-day'>Martes</p>
                    <div className='content-day-courses' id='content-tuesday'></div>
                </div>
                <hr/>
                <div className='content-day'>
                    <p className='title-day'>Miércoles</p>
                    <div className='content-day-courses' id='content-wednesday' ></div>
                </div>
                <hr/>
                <div className='content-day'>
                    <p className='title-day'>Jueves</p>
                    <div className='content-day-courses' id='content-thursday' ></div>
                </div>
                <hr/>
                <div className='content-day'>
                    <p className='title-day'>Viernes</p>
                    <div className='content-day-courses' id='content-friday' ></div>
                </div>
                <hr/>
                <div className='content-day'>
                    <p className='title-day'>Sábado</p>
                    <div className='content-day-courses' id='content-saturday' ></div>
                </div>
            </div>
        </div>
    )
}

/* const courses = [
    { label: 'Física I - 1° 12', start: '18:15', end: '22:15'}
    
  ]; */
